$(document).on("turbo:load", function () {
  Dropzone.autoDiscover = false;
  // Initialize all dropzones on the page
  $('.my-dropzone').each(function () {
    initializeDropzone(this);
  });
});

function initializeDropzone(el) {
  var $dropzoneElement = $(el);
  var relatedFieldId = $dropzoneElement.data('related-field');
  var $relatedInput = $('#' + relatedFieldId);
  if (!$relatedInput.length) return;

  var relatedId = $relatedInput.val();
  var destination = $dropzoneElement.data('destination') || 'Progress';
  var maxImages = parseInt($dropzoneElement.data('max-images')) || 10;
  var isRequired = $dropzoneElement.data('required') !== false && $dropzoneElement.data('required') !== 'false';

  var form_button = $relatedInput.closest('form').find('.with-dropzone');
  form_button.prop('disabled', isRequired);

  // Explicit "add more" affordance: once a preview thumbnail is showing, the dropzone's
  // own placeholder text/click area is covered/hidden (see .dz-started .dz-message in
  // dropzone.min.css), so users can't tell they can still tap to add more photos.
  var $addMoreBtn = $('<button type="button" class="btn btn-outline-primary btn-sm dz-add-more mt-2 d-none">+ Dodaj još slika</button>');
  $dropzoneElement.after($addMoreBtn);
  $addMoreBtn.on('click', function () {
    dz.hiddenFileInput.click();
  });

  var totalFiles = 0; // Track the total number of files
  var completedFiles = 0; // Track the number of completed uploads in the current set

  function updateAddMoreButton() {
    var currentCount = dz.files.length;
    $addMoreBtn.toggleClass('d-none', !(currentCount > 0 && currentCount < maxImages));
  }

  var dz = new Dropzone($dropzoneElement[0], {
    url: `/images?related_id=${relatedId}&model=${destination}`,
    maxFiles: maxImages,
    resizeWidth: 1024,
    resizeQuality: 1,
    parallelUploads: 2,
    paramName: 'image',
    acceptedFiles: 'image/*',
    addRemoveLinks: true,
    dictRemoveFile: 'Ukloni',
    dictDefaultMessage: "Klikni ovdje za odabir slika!<br><small>Savjet: za odabir više fotografija odjednom iz galerije, drži prst na prvoj fotografiji par sekundi dok se ne uključi mogućnost višestrukog odabira, pa dodirni i ostale fotografije.</small>",
    dictCancelUpload: '',
    dictMaxFilesExceeded: `Dopušteni broj slika: ${maxImages} - uklonite višak!`,
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    init: function () {
      this.on('removedfile', function (file) {
        if (file.imageId) {
          $.ajax({
            method: 'DELETE',
            url: `/images/${file.imageId}`,
          });
        }

        if (this.files.length === 0 && completedFiles === totalFiles) {
          form_button.prop('disabled', isRequired);
        }
        updateAddMoreButton();
      });

      this.on('addedfile', function () {
        totalFiles++; // Increment total files when a file is added
        form_button.prop('disabled', true);
        updateAddMoreButton();
      });

      this.on('success', function (file, response) {
        var imageId = response.id;
        file.imageId = imageId;
        completedFiles++; // Increment completed files on success

        if (completedFiles === totalFiles) {
          form_button.prop('disabled', false);
          totalFiles = 0;
          completedFiles = 0;
        }
      });

      this.on('error', function (file) {
        alert(`Došlo je do greške. Dopušteni broj slika: ${maxImages}! Pokušajte ponovno`);
        this.removeFile(file);
      });
    }
  });
}